export function updateI18nAttributes(
  this: any, // TODO use GrapesJSComponent instead of any
  locale: string,
  values: { [key: string]: any },
) {
  const model = this.model ?? this;
  const currentI18nAttributes = model.attributes.i18nAttributes || {};
  const currentLocaleAttributes = currentI18nAttributes[locale] ?? {};

  model.set('i18nAttributes', {
    ...currentI18nAttributes,
    [locale]: {
      ...currentLocaleAttributes,
      ...values,
    },
  });
}
